import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ClientService } from "../service/client.service";
import { SupportCallModel } from "../model/SupportCallModel";
import { CallFollowUp } from "../model/callFollowUp";
import { CallDetailItem } from "../model/callDetailItem";
import { UpdateOrderNumberRequest } from "../model/updateOrderNumberRequest";
import { Supplier } from "../model/supplier";
import { SupplierManagementService } from "../service/supplier-management.service";
import { SendSupplierRequest } from "../model/sendSupplierRequest";
import { CallEmailHistoryModel } from "../model/callEmailHistoryModel";
import { ClientModel } from "../model/clientModel";
import { UserWithSupplierDto } from "../model/userWithSupplierDTO";
import { CallTypeModel } from "../model/callType";
import { UpdateCallTypeForCallModel } from "../model/updateCallTypeForCallModel";

@Component({
  selector: "app-call-request-details",
  templateUrl: "./call-request-details.component.html",
  styleUrls: ["./call-request-details.component.css"],
})
export class CallRequestDetailsComponent implements OnInit {
  callId: number | null = null;
  isLoading = false;
  originalCallData: SupportCallModel = null; // Replace with proper model later

  showSupportCalls: boolean = false;

  newCallDetails: string = "";

  newFollowUpCall: CallFollowUp = { OriginalCallId: 0, CallDetails: "" };

  callDetailsHistory: CallDetailItem[] = [];

  isEditingOrderNumber = false;
  editedOrderNumber: string = "";

  suppliers: Supplier[] = [];

  filteredSuppliers: Supplier[] = [];
  selectedSupplier: Supplier = null;

  selectedFollowUp: CallDetailItem | null = null;

  callEmailHistory: CallEmailHistoryModel[] = [];

  callEmailHistoryMap: { [callDetailsId: number]: CallEmailHistoryModel[] } =
    {};

  clientId: number;

  client: ClientModel;

  usersWithSuppliers: UserWithSupplierDto[] = [];
  filteredUsers: UserWithSupplierDto[] = [];
  selectedUser: UserWithSupplierDto | null = null;

  usersWithoutSuppliers: UserWithSupplierDto[] = [];
  filteredUsersWithoutSuppliers: UserWithSupplierDto[] = [];
  selectedUserWithoutSupplier: UserWithSupplierDto | null = null;

  callTypes: CallTypeModel[] = [];

  isEditingCallType = false;
  selectedCallTypeId: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
    private supplierService: SupplierManagementService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadCallDetails();
    this.loadCallHistory();
    this.getAllSuppliers();
    this.loadCallEmailHistory();
    this.getAllUsersWithActiveSupplier();
    this.getAllUsersWithoutSupplier();
    this.loadCallTypes();
  }

  loadCallDetails() {
    const idParam = this.route.snapshot.paramMap.get("callId");
    if (!idParam) return;

    this.callId = +idParam;
    this.isLoading = true;

    this.clientService.getCallDetailsById(this.callId).subscribe(
      (response: SupportCallModel) => {
        this.originalCallData = response;
        console.log("originalCallData:", this.originalCallData);
        this.clientId = this.originalCallData.ClientId;

        this.loadClient();
        this.isLoading = false;
      },
      (error) => {
        console.error("Error loading call details:", error);
        this.isLoading = false;
      },
    );
  }

  continueCallRequest = () => {
    this.showSupportCalls = !this.showSupportCalls;
  };

  submitNewCallDetails = () => {
    this.newFollowUpCall.OriginalCallId = this.originalCallData.CallId;
    this.newFollowUpCall.CallDetails = this.newCallDetails;

    console.log("newFollowUpCall:", this.newFollowUpCall);

    this.clientService.newFollowUpCall(this.newFollowUpCall).subscribe(
      (response) => {
        console.log(response);
        if (response) {
          alert("הפניה נוספה בהצלחה");
          this.showSupportCalls = false;
          this.newCallDetails = "";
          this.loadCallHistory();
        }
      },
      (error) => {
        console.log(error);
      },
    );
  };

  loadCallHistory = () => {
    this.clientService.getCallDetailsHistory(this.callId).subscribe(
      (response) => {
        // console.log(response);
        this.callDetailsHistory = response.slice().reverse();
      },
      (error) => {
        console.log(error);
      },
    );
  };

  toggleCallStatus = () => {
    if (!confirm("האם אתה בטוח שברצונך לסגור/לפתוח את הפניה?")) {
      return;
    }

    console.log("Closing callId:", this.callId);

    this.clientService.toggleCallStatus(this.callId).subscribe(
      (res: boolean) => {
        if (res) {
          alert("הפניה נסגרה/נפתחה בהצלחה");
          this.loadCallDetails(); // or reload page / navigate
        } else {
          alert("משהו השתבש...");
        }
      },
      (err) => {
        console.error(err);
        alert("שגיאת שרת");
      },
    );
  };

  startEditOrderNumber() {
    this.editedOrderNumber = this.originalCallData.OrderNumber || "";
    this.isEditingOrderNumber = true;
  }

  cancelEditOrderNumber() {
    this.isEditingOrderNumber = false;
    this.editedOrderNumber = "";
  }

  saveOrderNumber = () => {
    if (!this.originalCallData.CallId) return;

    var newOrderNumber =
      this.editedOrderNumber && this.editedOrderNumber.trim() !== ""
        ? this.editedOrderNumber.trim()
        : null;

    const payload: UpdateOrderNumberRequest = {
      CallId: this.originalCallData.CallId,
      OrderNumber: newOrderNumber,
    };

    this.clientService.updateOrderNumber(payload).subscribe(
      (res) => {
        if (res) {
          // עדכון UI
          this.originalCallData.OrderNumber = this.editedOrderNumber;
          this.isEditingOrderNumber = false;
          alert("מספר הזמנה עודכן בהצלחה!");
        } else {
          alert("תקלה בעידכון מספר ההזמנה");
        }
      },
      (err) => {
        console.error(err);
        alert("Server error while updating OrderNumber");
      },
    );
  };

  goBack() {
    window.history.back();
  }

  getAllSuppliers = () => {
    this.supplierService.getSuppliers().subscribe(
      (response: Supplier[]) => {
        // Only active suppliers
        this.suppliers = response.filter((s) => s.Active);
        // Optionally pre-populate the first 50 for performance
        this.filteredSuppliers = this.suppliers.slice(0, 50);

        // console.log("filteredSuppliers:", this.filteredSuppliers);
      },
      (error) => console.log(error),
    );
  };

  // Called by p-autoComplete when user types
  searchSuppliers(event: { query: string }) {
    const term = event.query.toLowerCase().trim();
    if (!term) {
      this.filteredSuppliers = this.suppliers.slice(0, 50);
    } else {
      this.filteredSuppliers = this.suppliers
        .filter((s) => s.Name.toLowerCase().includes(term))
        .slice(0, 50);
    }
  }

  supplierSelected(event: any) {
    // The event contains the selected supplier object
    // console.log("Selected supplier:", event);
  }

  selectSingleFollowUp(item: CallDetailItem) {
    this.callDetailsHistory.forEach((h) => (h.selected = false));
    item.selected = true;
    this.selectedFollowUp = item;
  }

  loadCallEmailHistory = () => {
    if (!this.callId) {
      this.callEmailHistory = [];
      this.callEmailHistoryMap = {};
      return;
    }

    this.clientService.getCallEmailHistory(this.callId).subscribe(
      (response) => {
        // SQL כבר מחזיר מהאחרון לראשון
        this.callEmailHistory = response;

        // console.log("callEmailHistory:", this.callEmailHistory);

        // Precompute map for faster lookup
        this.callEmailHistoryMap = {};
        this.callEmailHistory.forEach((e) => {
          if (!this.callEmailHistoryMap[e.CallDetailsId]) {
            this.callEmailHistoryMap[e.CallDetailsId] = [];
          }
          // push רגיל → שומר את הסדר מה-SP
          this.callEmailHistoryMap[e.CallDetailsId].push(e);
        });
      },
      (error) => {
        console.log(error);
        this.callEmailHistory = [];
        this.callEmailHistoryMap = {};
      },
    );
  };

  loadClient() {
    this.clientService.getClientById(this.clientId).subscribe(
      (response: ClientModel) => {
        this.client = response;
        // console.log("Client:", this.client);
      },
      (error) => {
        console.error("Error loading client details:", error);

        this.isLoading = false;
      },
    );
  }

  getAllUsersWithActiveSupplier() {
    this.clientService.getAllUsersWithActiveSupplier().subscribe(
      (response: UserWithSupplierDto[]) => {
        // create a new property "DisplayName" = UserName + SupplierName
        this.usersWithSuppliers = response.map((u) => ({
          ...u,
          DisplayName: `${u.UserName} (${u.SupplierName})`,
        }));

        // pre-populate the first 50 for performance
        this.filteredUsers = this.usersWithSuppliers.slice(0, 50);

        // console.log("usersWithSuppliers:", this.filteredUsers);
      },
      (error) => console.log(error),
    );
  }

  searchUsers(event: { query: string }) {
    const term = event.query.toLowerCase().trim();
    if (!term) {
      this.filteredUsers = this.usersWithSuppliers.slice(0, 50);
    } else {
      this.filteredUsers = this.usersWithSuppliers
        .filter((u) => u.DisplayName.toLowerCase().includes(term))
        .slice(0, 50);
    }
  }

  userSelected(event: UserWithSupplierDto) {
    console.log("Selected user:", event);
    this.selectedUser = event;
  }

  getAllUsersWithoutSupplier() {
    this.clientService.getAllUsersWithoutSupplier().subscribe(
      (response: UserWithSupplierDto[]) => {
        this.usersWithoutSuppliers = response.map((u) => ({
          ...u,
          DisplayName: u.UserName,
        }));

        this.filteredUsersWithoutSuppliers = this.usersWithoutSuppliers.slice(
          0,
          50,
        );

        // console.log(
        //   "usersWithoutSuppliers:",
        //   this.filteredUsersWithoutSuppliers,
        // );
      },
      (error) => console.log(error),
    );
  }

  searchUsersWithoutSupplier(event: { query: string }) {
    const term = (event.query || "").toLowerCase().trim();

    if (!term) {
      this.filteredUsersWithoutSuppliers = this.usersWithoutSuppliers.slice(
        0,
        50,
      );
    } else {
      this.filteredUsersWithoutSuppliers = this.usersWithoutSuppliers
        .filter((u) => u.DisplayName.toLowerCase().includes(term))
        .slice(0, 50);
    }
  }

  userWithoutSupplierSelected(event: UserWithSupplierDto) {
    console.log("Selected user without supplier:", event);
    this.selectedUserWithoutSupplier = event;
  }

  // upload file logic -
  onFileSelected(event: Event, item: CallDetailItem) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      item.attachmentFile = input.files[0];

      // Optional: auto-select the call when uploading a file
      this.selectSingleFollowUp(item);
    }
  }

  sendEmail(
    endpoint: "user" | "userWithoutSupplier" | "supplier",
    targetId: string | number,
  ) {
    if (!this.selectedFollowUp || !targetId) {
      alert("בבקשה בחר משתמש וסמן איזו פניה לשלוח");
      return;
    }

    // confirm רק למשתמש רגיל
    if (endpoint === "user" && this.originalCallData.OrderNumber) {
      const confirmed = confirm(
        "מכיוון שקיים מספר הזמנה תיווצר הזמנה חדשה במערכת",
      );
      if (!confirmed) return;
    }

    const formData = this.buildFormData(targetId, endpoint);

    this.clientService.send(endpoint, formData).subscribe(
      (res: any) => this.handleSendResult(res),
      (err) => console.error(err),
    );
  }

  private buildFormData(targetId: string | number, endpoint: string): FormData {
    const formData = new FormData();

    formData.append("CallId", this.originalCallData.CallId.toString());
    formData.append(
      "CallDetailsId",
      this.selectedFollowUp.CallDetailsId.toString(),
    );

    // משתמש רגיל / ללא ספק → UserId
    if (endpoint === "user" || endpoint === "userWithoutSupplier") {
      formData.append("UserId", targetId.toString());
    }
    // ספק → SupplierId
    else if (endpoint === "supplier") {
      formData.append("SupplierId", targetId.toString());
    }

    formData.append("OrderNumber", this.originalCallData.OrderNumber || "");

    if (this.selectedFollowUp.attachmentFile) {
      formData.append(
        "Attachment",
        this.selectedFollowUp.attachmentFile,
        this.selectedFollowUp.attachmentFile.name,
      );
    }

    return formData;
  }

  private handleSendResult(res: any) {
    if (res.emailSent && res.orderCreated) {
      alert("נשלח בהצלחה ונוצרה הזמנה");
    } else if (res.emailSent) {
      alert("המייל נשלח (לא נוצרה הזמנה)");
    } else {
      alert("שליחה נכשלה");
    }

    this.selectedUser = null;
    this.selectedUserWithoutSupplier = null;
    this.selectedSupplier = null;

    this.loadCallEmailHistory();
  }

  sendToSupplier() {
    if (!this.selectedSupplier) {
      return;
    }

    console.log("Supplier Id:", this.selectedSupplier.Id);

    this.sendEmail("supplier", this.selectedSupplier.Id);
  }

  sendToUserWithoutSupplier() {
    if (!this.selectedUserWithoutSupplier) {
      return;
    }

    this.sendEmail(
      "userWithoutSupplier",
      this.selectedUserWithoutSupplier.UserId,
    );
  }

  sendToUser() {
    if (!this.selectedUser) {
      return;
    }

    this.sendEmail("user", this.selectedUser.UserId);
  }

  moveToUpdateOrderPage = () => {
    let orderNumber = "";

    if (this.originalCallData && this.originalCallData.OrderNumber) {
      orderNumber = this.originalCallData.OrderNumber;
    }

    let url = "/updateOrder";

    if (orderNumber) {
      url += `?orderNumber=${orderNumber}`;
    }

    // open in a new tab
    window.open(url, "_blank");
  };

  loadCallTypes() {
    this.clientService.getAllCallTypes().subscribe(
      (response) => {
        console.log("Call types:", response);
        this.callTypes = response;
      },
      (error) => console.log(error),
    );
  }

  startEditCallType() {
    this.isEditingCallType = true;
    this.selectedCallTypeId = this.originalCallData.CallTypeId;

    if (!this.callTypes || this.callTypes.length === 0) {
      this.loadCallTypes();
    }
  }

  cancelEditCallType() {
    this.isEditingCallType = false;
    this.selectedCallTypeId = null;
  }

  saveCallType() {
    if (!this.selectedCallTypeId) return;

    const payload: UpdateCallTypeForCallModel = {
      CallId: this.originalCallData.CallId,
      CallTypeId: this.selectedCallTypeId,
    };

    this.clientService.updateCallTypeForCall(payload).subscribe(
      (response) => {
        if (response) {
          alert("השינוי בוצע בהצלחה");
        }

        // update UI locally
        const selectedType = this.callTypes.find(
          (x) => x.CallTypeId === this.selectedCallTypeId,
        );

        if (selectedType) {
          this.originalCallData.CallTypeId = selectedType.CallTypeId;
          this.originalCallData.CallTypeDescription =
            selectedType.CallTypeDescription;
        }

        this.isEditingCallType = false;
      },
      (error) => {
        console.log(error);
        alert("השינוי ניכשל...");
      },
    );
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/call-request-details/call-request-details.component.ts